export default __webpack_public_path__ + "static/media/purewow_grey.b7b67382.webp";